<template>
  <div class="business"> 
       <div class="top">
        <div class="iconbox">
          <div class="icon"></div>
        </div>
        <div class="title">
          <div class="r_t_chtitle">{{$t('news')}}</div>
          <div class="r_t_entitle">News</div>
        </div>
      </div>
      <ul class="newstoplist">
          <li class="newstop_li" v-for="(item,index) in newslist" :key="index" v-show="index<3" @click="newsdetails_func(item.id)">
              <div class="n_li_body">
                <img :src="item.pic" alt="">
                <div class="n_li_bottom">
                    <div class="n_li_b_left">
                        <div class="newtitle">{{item.title}}</div>
                        <div class="newstime">{{item.published_ats}}</div>
                    </div>
                    <div class="n_li_b_right">
                        <img src="../../assets/images/p8.png" alt="" >
                    </div>
                </div>
              </div>
          </li>
      </ul>
<!-- 新闻中心 -->
     <div class="business_c">
         <ul class="b_c_ul">
             <li class="b_c_li"
              
                v-for="(item,index) in newslist" :key="index" v-show="index>=3"
                @click="newsdetails_func(item.id)"
                >
                <div class="b_c_li_body">
                <div class="left">
                    <img :src="item.pic" alt="">
                </div>
                <div class="right"   >
                    <div class="newstitle">{{item.title}}</div>
                     <span>{{item.published_ats}}</span>
                    <div class="newscontent" v-html="item.content"></div>
                   
                </div>
                </div>
             </li>
         </ul>
          
     </div>
    
   
  </div>
</template>

<script>

import {newsgetNewList} from "../../api/request.js";
export default {
    name:'Business',
    data() {
        return {
           newslist:[]
        }
    },
    components: {
       
    },
    mounted () {

        this.newsgetNewList_func();
       
    },
    destroyed () {
      
    },
    methods: {

      newsdetails_func(id){

          this.$router.push({'path':'/newsdetails',query:{'id':id}});

      },

      //新闻动态
      newsgetNewList_func(){

          newsgetNewList({'page':1,'limit':99999}).then((res)=>{

              for(var item of res.data.data){

                  if(item.published_at){

                    let time = item.published_at.split('-');

                    item.published_ats = time[0] + '年' + time[1] + '月' + time[2] + '日';
                   
                  }
              }
              this.newslist = res.data.data;

          });

      },

    },
}
</script>

<style lang='less' scoped>
.business{
    width: 100%;
    margin-top: 200px;
   .top {
      border-bottom: 1px solid #20386b;
      width: 1200px;
      display: flex;
      justify-content: flex-start;
      margin:0 auto;
      margin-top: 60px;
      .iconbox {
        // border: 1px solid #000;
        height: 38px;
        width: 18.24px;
        position: relative;
        overflow: hidden;
        .icon {
          height: 100px;
          width: 10.56px;
          background: #163979;
          position: absolute;
          top: -10px;
          transform: rotateZ(10deg);
        }
      }
      .title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 4px;
        .r_t_chtitle {
          height: 33px;
          font-size: 26px;
          font-family: Microsoft YaHei UI;
          font-weight: bold;
          line-height: 33px;
          color: rgba(25, 59, 127, 1);
        }
        .r_t_entitle {
          // border: 1px solid #000;
          height: 23px;
          font-size: 18px;
          font-family: Microsoft YaHei UI;
          font-weight: 400;
          line-height: 23px;
          color: rgba(25, 59, 127, 1);
          padding-top: 13px;
          margin-left: 5px;
        }
      }
    }
    .newstoplist{
        // border: 1px solid #000;
        width: 1200px;
        margin:0 auto;
        margin-top:60px;
        display: flex;
        justify-content: flex-start;
        .newstop_li{
            // border: 1px solid #000;
           width: 385px;
            height: 293px;
            cursor: pointer;
            .n_li_body{
                // border: 1px solid red;
                width: 385px;
                height: 293px;
                position: relative;
                img{
                     width: 385px;
                height: 293px;
                object-fit: cover;
                }
                .n_li_bottom{
                    width: 385px;
                    height:79px;
                    background:rgba(25,59,127,0.6);
                    position: absolute;
                    bottom: 0;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    transition: all 0.5s;
                    .n_li_b_left{
                        width: 300px;
                         margin-left:10px;
                        .newtitle{
                       
                        height:25px;
                        font-size:20px;
                        font-family:Microsoft YaHei UI;
                        font-weight:bold;
                        line-height:25px;
                        color:rgba(255,255,255,1);
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                       
                      
                        }
                        .newstime{
                            
                            height:30px;
                            font-size:14px;
                            font-family:Microsoft YaHei UI;
                            font-weight:300;
                            line-height:30px;
                            color:rgba(255,255,255,1);
                            
                           
                        }
                    }
                    .n_li_b_right{
                          margin-right:10px;
                           width: 0px;
                           overflow: hidden;
                           transition: all 0.5s;
                         img{
                            
                             width: 24px;
                             height: 24px;
                            
                         }
                    }
                }
            }
        }
        .newstop_li+.newstop_li{
            margin-left: 22px;
        }
        .newstop_li:hover{
            .n_li_bottom{
                 background:rgba(25,59,127,1);
                 .n_li_b_right{
                      width: 24px;
                     
                 }
            }
        }
    }
    .business_c{
        width: 1200px;
        margin: 0 auto;
         margin-top: 60px;  
         margin-bottom: 60px;
        .b_c_ul{
            // border: 1px solid #000;
             width: 1200px;
              display: flex;
                 justify-content: flex-start;
                 flex-wrap: wrap;
                  
            .b_c_li{
                //  border:1px solid red;
                 width: 600px;
                 height: 171px;
                 position: relative;
                 margin-top: 10px;  
                 display: flex;
                 justify-content: flex-start;
                //  background:rgba(250,250,250,1);
                // background:red;
                //  align-items:center; 
                .b_c_li_body{
                    // border: 1px solid #000;
                     width: 580px;
                     display: flex;
                 justify-content: flex-start;
                 background: #FAFAFA;
                 .left{
                    //  border: 1px solid #000;
                     width: 257.95px;
                     height: 171px;
                     overflow: hidden;
                     img{
                        width: 257.95px;
                        height: 171px;
                        object-fit: cover;
                        transition: all 0.5s;
                        cursor: pointer;
                     }
                     img:hover{
                         transform: scale(1.5);
                     }
                 }
                 .right{
                    //  border: 1px solid #000;
                     width:300px;
                    height: 171px;
                    overflow: hidden;
                    margin-left: 20px;
                     .newstitle{
                        //  border: 1px solid #000;
                        width:280px;
                        height:40px;
                        font-size:20px;
                        font-family:Source Han Sans CN;
                        font-weight:bold;
                        line-height: 40px;
                        color:rgba(51,51,51,1);
                         cursor: pointer;
                         white-space: nowrap;
                         overflow: hidden;
                         text-overflow: ellipsis;
                     }
                     .newstitle:hover{
                          color: rgba(25, 59, 127, 1);
                     }
                       span{
                            font-size:14px;
                            font-family:Source Han Sans CN;
                            font-weight:400;
                            color:#4A4D50;
                            display: inline-block;
                         }
                     .newscontent{
                         width:280px;
                        font-size:14px;
                        font-family:Source Han Sans CN;
                        font-weight:400;
                        color:#888888;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 3;
                        -webkit-box-orient: vertical;
                        line-height: 24px;
                        cursor: pointer;
                        margin-top: 15px;
                     }
                     .newscontent:hover{
                         color: rgba(25, 59, 127, 1);
                     }
                 }
                
            }
            }
        }
    }
}
</style>